import React, { useEffect, useState } from "react";
import useTable from "../../../../../components/useTable";
import axios from 'axios';
import { Input, Select } from "../../../../../ui/inputs/Input";
import { InfoButton, WarningButton } from "../../../../../ui/buttons/Button";
import { ModalEditarConcepto } from "../modals/ModalEditarConcepto";

const headCells = [
  {
    id: "activo",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Activo",
    textAlign: "center",
  },
  {
    id: "codconcep",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Cod. Concepto",
    textAlign: "center",
  },
  {
    id: "nomconcep",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Nombre",
    textAlign: "center",
  },
];

export default function TablaConceptoNomina(props) {
  var op = require('../../../../../../src/modulos/datos');

  let token = localStorage.getItem('jwtToken');
  const [records, setRecords] = useState([]);
  const [activate, setActivate] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);

  // Estados para el modal
  const [modalVisible, setModalVisible] = useState(false);
  const [modalOperacion, setModalOperacion] = useState(2); // 2: editar, 4: consultar
  const [conceptoSeleccionado, setConceptoSeleccionado] = useState(null);

  // Estados para búsqueda
  const [searchTerm, setSearchTerm] = useState("");
  const [searchField, setSearchField] = useState("codconcep");

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      if (searchTerm === "") return items;
      const searchLower = searchTerm.toLowerCase().trim();
      return items.filter(item =>
        item[searchField]?.toLowerCase().includes(searchLower)
      );
    },
  });

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const { TblContainer, TblHead, recordsAfterPagingAndSorting } = useTable(
    records,
    headCells,
    filterFn
  );

  // Actualizar filtro cuando cambia búsqueda
  useEffect(() => {
    setFilterFn({
      fn: (items) => {
        if (searchTerm === "") return items;
        const searchLower = searchTerm.toLowerCase().trim();
        return items.filter(item =>
          item[searchField]?.toLowerCase().includes(searchLower)
        );
      },
    });
  }, [searchTerm, searchField]);

  const seleccionarConceptos = (codIntegrante) => {
    if (!codIntegrante) return;

    let codigoNomina = localStorage.getItem('codigonomina')?.replace(/"/g, '');
    let esquema = `nomi${codigoNomina}`;
    let id = codIntegrante;
    let bloquear = false;
    let condi = "t4.status = 1 ";
    let nomtab = 'conceptosinte';
    let endpoint = `${op.conexion}/api/nomina/seleccionarconceptosinte2condi?esquema=${esquema}&id=${id}&bloquear=${bloquear}&condi=${condi}&nomtab=${nomtab}`;

    setActivate(true);
    axios.get(endpoint, {
      headers: { "x-access-token": `${token}` }
    })
      .then(response => {
        if (response.status === 200) {
          console.log('Conceptos cargados:', response.data);
          setRecords(response.data);
          // Resetear selección cuando cambia el integrante
          setSelectedRow(null);
          setSelectedItem(null);
          setSearchTerm("");
        }
      })
      .catch(error => {
        setMensaje({
          mostrar: true,
          titulo: 'Error',
          texto: error.response?.data?.message || 'Error al cargar los conceptos',
          icono: 'error'
        });
        setTimeout(() => setMensaje({ ...mensaje, mostrar: false }), 3000);
      })
      .finally(() => setActivate(false));
  };

  const seleccionarFila = (item) => {
    return () => {
      setSelectedRow(item.codconcep);
      setSelectedItem(item);
      console.log("Fila seleccionada:", item);
    };
  };

  // Función para consultar concepto
  const handleConsultar = () => {
    if (!selectedItem) {
      alert('Seleccione un concepto para consultar');
      return;
    }

    console.log('Consultando concepto:', selectedItem);
    setConceptoSeleccionado(selectedItem);
    setModalOperacion(4); // Consultar
    setModalVisible(true);
  };

  // Función para editar concepto (nombre)
  const handleEditar = () => {
    if (!selectedItem) {
      alert('Seleccione un concepto para editar');
      return;
    }

    console.log('Editando concepto:', selectedItem);
    setConceptoSeleccionado(selectedItem);
    setModalOperacion(2); // Editar
    setModalVisible(true);
  };

  // Función para manejar la respuesta del modal (actualizar nombre)
  // Función para manejar la respuesta del modal (actualizar nombre y/o activo)
  const handleModalAceptar = async (datos) => {
    console.log('Concepto a actualizar:', datos);

    try {
      let codigoNomina = localStorage.getItem('codigonomina')?.replace(/"/g, '');
      let esquema = `nomi${codigoNomina}`;

      // Llamar al endpoint conceptosinte_act con operacion = 2 (UPDATE)
      let endpoint = `${op.conexion}/api/nomina/conceptosinte_act?operacion=2`;

      const payload = {
        p_operacion: 2,                    // UPDATE
        p_codint: datos.codint,
        p_codconcep: datos.codconcep,
        p_activo: datos.activo,            // Actualizar activo
        p_activopagos: datos.activopagos,  // Mantener activopagos
        p_nomconcep: datos.nomconcep,      // Actualizar nombre
        p_esquema: esquema
      };

      const response = await axios.post(endpoint, payload, {
        headers: { "x-access-token": `${token}` }
      });

      if (response.status === 200) {
        setMensaje({
          mostrar: true,
          titulo: 'Éxito',
          texto: 'Concepto actualizado correctamente',
          icono: 'success'
        });

        // Recargar la tabla
        seleccionarConceptos(props.codIntegrante);

        // Limpiar selección
        setSelectedRow(null);
        setSelectedItem(null);

        setTimeout(() => setMensaje({ ...mensaje, mostrar: false }), 3000);
      }
    } catch (error) {
      console.error('Error al actualizar concepto:', error);
      setMensaje({
        mostrar: true,
        titulo: 'Error',
        texto: error.response?.data?.message || error.message || 'Error al actualizar el concepto',
        icono: 'error'
      });
      setTimeout(() => setMensaje({ ...mensaje, mostrar: false }), 3000);
    }

    setModalVisible(false);
  };

  // Función para actualizar el estado (checkbox)
  const handleCheckboxChange = async (item, checked) => {
    console.log(`Cambiar activo para ${item.codconcep} a ${checked}`);

    try {
      let codigoNomina = localStorage.getItem('codigonomina')?.replace(/"/g, '');
      let esquema = `nomi${codigoNomina}`;

      let endpoint = `${op.conexion}/api/nomina/conceptosinte_act?operacion=2`;

      const payload = {
        p_operacion: 2,                    // UPDATE
        p_codint: props.codIntegrante,
        p_codconcep: item.codconcep,
        p_activo: checked,                 // Actualizar activo
        p_activopagos: item.activopagos || false,
        p_nomconcep: undefined,            // No actualizar nombre
        p_esquema: esquema
      };

      const response = await axios.post(endpoint, payload, {
        headers: { "x-access-token": `${token}` }
      });

      if (response.status === 200) {
        // Actualizar estado local sin recargar toda la tabla
        const updatedRecords = records.map(record =>
          record.codconcep === item.codconcep
            ? { ...record, activo: checked }
            : record
        );
        setRecords(updatedRecords);

        setMensaje({
          mostrar: true,
          titulo: 'Éxito',
          texto: 'Estado actualizado correctamente',
          icono: 'success'
        });
        setTimeout(() => setMensaje({ ...mensaje, mostrar: false }), 2000);
      }
    } catch (error) {
      console.error('Error al actualizar estado:', error);
      setMensaje({
        mostrar: true,
        titulo: 'Error',
        texto: error.response?.data?.message || error.message || 'Error al actualizar el estado',
        icono: 'error'
      });
      setTimeout(() => setMensaje({ ...mensaje, mostrar: false }), 3000);
    }
  };

  useEffect(() => {
    if (props.codIntegrante) {
      seleccionarConceptos(props.codIntegrante);
    }
  }, [props.codIntegrante]);

  return (
    <div className="col-12 m-0 p-0 d-flex flex-wrap">
      {/* Mensaje de alerta */}
      {mensaje.mostrar && (
        <div className={`alert alert-${mensaje.icono === 'error' ? 'danger' : 'success'} col-12 mb-2 alert-dismissible fade show`} role="alert">
          <i className={`fa fa-${mensaje.icono === 'error' ? 'exclamation-circle' : 'check-circle'} me-2`}></i>
          {mensaje.texto}
          <button type="button" className="btn-close" onClick={() => setMensaje({ ...mensaje, mostrar: false })}></button>
        </div>
      )}

      {/* Barra de búsqueda y botones de acción */}
      <div className="col-12 m-0 mb-2 p-0 d-flex gap-2">
        <div className="col-3 m-0 p-0">
          <Select
            label="Buscar por:"
            value={searchField}
            onChange={(e) => setSearchField(e.target.value)}
          >
            <option value="codconcep">Cod. Concepto</option>
            <option value="nomconcep">Nombre</option>
          </Select>
        </div>
        <div className="col-7 m-0 p-0">
          <Input
            placeholder="Ingrese criterio de búsqueda"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="col-2 m-0 d-flex d-flex justify-content-end">
          <button
            className="btn btn-info btn-sm rounded-circle ml-2"
            onClick={handleConsultar}
            disabled={!selectedItem}
            title="Consultar concepto"
          >
            <i className="fa fa-eye me-1"></i>
          </button>
          <button
            className="btn btn-warning btn-sm rounded-circle ml-2"
            onClick={handleEditar}
            disabled={!selectedItem}
            title="Editar concepto"
          >
            <i className="fa fa-edit me-1"></i>
          </button>
        </div>
      </div>

      {/* Tabla de conceptos */}
      <div className="col-12 m-0 p-0">
        <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
          <TblContainer>
            <TblHead />
            <tbody>
              {records && records.length > 0 ? (
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr
                    key={index}
                    style={{
                      padding: "0",
                      cursor: 'pointer',
                      backgroundColor: selectedRow === item.codconcep ? "#e3f2fd" : "transparent",
                      transition: 'background-color 0.2s ease'
                    }}
                    onClick={seleccionarFila(item)}
                    onMouseEnter={(e) => {
                      if (selectedRow !== item.codconcep) {
                        e.currentTarget.style.backgroundColor = '#f5f5f5';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (selectedRow !== item.codconcep) {
                        e.currentTarget.style.backgroundColor = 'transparent';
                      }
                    }}
                  >
                    <td className="text-center" onClick={(e) => e.stopPropagation()}>
                      <input
                        type="checkbox"
                        checked={item.activo === true || item.activo === 1}
                        onChange={(e) => handleCheckboxChange(item, e.target.checked)}
                        className="form-check-input"
                      />
                    </td>
                    <td className="text-center">{item.codconcep}</td>
                    <td className="text-left">{item.nomconcep}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" className="text-center py-4">
                    <i className="fa fa-inbox fa-2x text-muted mb-2 d-block"></i>
                    No hay conceptos de nómina para mostrar
                  </td>
                </tr>
              )}
            </tbody>
          </TblContainer>
        </div>
      </div>

      {/* Mostrar total de registros */}
      {records && records.length > 0 && (
        <div className="col-12 mt-2 text-muted small">
          Total de conceptos: {records.length} |
          Mostrando: {recordsAfterPagingAndSorting().length} conceptos
        </div>
      )}

      {/* Modal para editar/consultar concepto */}
      <ModalEditarConcepto
        show={modalVisible}
        onHide={() => {
          console.log('Cerrando modal');
          setModalVisible(false);
          setConceptoSeleccionado(null);
        }}
        operacion={modalOperacion}
        datos={conceptoSeleccionado}
        codIntegrante={props.codIntegrante}
        nomIntegrante={props.nomIntegrante}
        onAceptar={handleModalAceptar}
      />
    </div>
  );
}